module.exports = __webpack_public_path__ + "static/media/csr.096e5c42.svg";